var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecureIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6663 12.8331C16.6663 16.9997 13.7497 19.0831 10.283 20.2914C10.1015 20.3529 9.90429 20.35 9.72467 20.2831C6.24967 19.0831 3.33301 16.9997 3.33301 12.8331V6.99972C3.33301 6.77871 3.42081 6.56675 3.57709 6.41047C3.73337 6.25419 3.94533 6.16639 4.16634 6.16639C5.83301 6.16639 7.91634 5.16639 9.36634 3.89972C9.54289 3.74889 9.76747 3.66602 9.99967 3.66602C10.2319 3.66602 10.4565 3.74889 10.633 3.89972C12.0913 5.17472 14.1663 6.16639 15.833 6.16639C16.054 6.16639 16.266 6.25419 16.4223 6.41047C16.5785 6.56675 16.6663 6.77871 16.6663 6.99972V12.8331Z",
    stroke: "#D2042D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureIcon);
export default __webpack_public_path__ + "static/media/secure-icon.ac48e4cc96c5951d3422c3e719ed425e.svg";
export { ForwardRef as ReactComponent };